import { defineMessages } from 'react-intl';

export const clinicianUpgradeModalMessages = defineMessages({
  start14DayTrial: {
    defaultMessage: 'Start 14-day trial',
    id: 'vtXuNoac+6',
    description:
      'Primary CTA when the upgrade modal offers starting a 14-day Clinician trial',
  },
  upgradeToClinician: {
    defaultMessage: 'Upgrade to Clinician',
    id: 'uywnP/TmOC',
    description:
      'Primary CTA to purchase the Clinician plan (for example the 90-day trial recap variant)',
  },
  upgradeNow: {
    defaultMessage: 'Upgrade now',
    id: 'tF5I/CSqjp',
    description:
      'Primary CTA to upgrade to Clinician when not on the trial-recap variant',
  },
  extendYourTrial: {
    defaultMessage: 'Extend my trial',
    id: 'gtgnH9Z6i4',
    description: 'Secondary action to extend the Clinician trial from the upgrade modal',
  },
  viewAllPlans: {
    defaultMessage: 'View all plans',
    id: '6EnlTuHvTL',
    description: 'Secondary action to open the full pricing plans modal',
  },
  trialCTAFooterText: {
    defaultMessage:
      "Don't worry if the Clinician plan isn't for you. After your trial ends you can always use Heidi's free forever plan.",
    id: '3DPl4DtsmG',
    description:
      'Footer caption when the modal promotes starting a 14-day Clinician trial',
  },
  cancelAnytime: {
    defaultMessage: 'Cancel anytime',
    id: 'PjsGCjWK+Z',
    description:
      'Footer caption assuring users they can cancel their subscription anytime',
  },
  traineeVerificationNudge: {
    defaultMessage:
      "If you're a student or trainee, verify <traineeLink>here</traineeLink> for free access.",
    id: 'rtP3rzbFKV',
    description: 'Additional subtitle line with link to trainee sign-up for free access',
  },
  titleLevelUpCare: {
    defaultMessage: 'Level up your care with the Clinician plan',
    id: 'K15KGaSpWZ',
    description:
      'Clinician upgrade modal heading when the trial has ended or the user is not on Clinician Pro',
  },
  trialCTASubtitle: {
    defaultMessage:
      "Enjoy the best of Heidi free for 14 days. We'll remind you before your trial ends.",
    id: 'CoOAYw6pe0',
    description: 'Subtitle when the modal promotes starting a 14-day Clinician trial',
  },
  subtitleClinician: {
    defaultMessage:
      'Upgrade to keep all your Clinician features that help you save time.',
    id: 'GfKIU7t1sg',
    description:
      'Subtitle for users currently on a Clinician trial who are viewing the upgrade modal',
  },
  subtitleClinicianForScribePlus: {
    defaultMessage:
      'The Clinician plan takes Scribe Plus further — with clinical intelligence built around every consult.',
    id: 'cT4XDmpyiw',
    description: 'Subtitle for Scribe Plus users viewing the Clinician upgrade modal',
  },
  subtitleClinicianForNonTrial: {
    defaultMessage:
      'Everything you need to practise smarter — from the consult room to the chart.',
    id: 'VPc5CXmOV1',
    description:
      'Subtitle for users not on a Clinician trial who are viewing the Clinician upgrade modal',
  },
  everythingInScribePlus: {
    defaultMessage: 'Everything in Scribe Plus, with:',
    id: 'ZMTqg4RwNS',
    description:
      'Feature list heading for Scribe Plus users viewing the Clinician upgrade modal',
  },
  everythingInEvidencePlus: {
    defaultMessage: 'Everything in Evidence Plus, with:',
    id: 'hevVjYGBc6',
    description:
      'Feature list heading for Evidence Plus users viewing the Clinician upgrade modal',
  },
  everythingInFree: {
    defaultMessage: 'Everything in Free, plus:',
    id: 'pzAmFm4yvw',
    description:
      'Feature list heading for Free users viewing the Clinician upgrade modal',
  },
  everythingInCurrentPlanPlus: {
    defaultMessage: 'Everything in your current plan, plus:',
    id: 'hmDVJY+trX',
    description:
      'Feature list heading when the user has more than three trial days remaining',
  },
  everythingInPlanPlus: {
    defaultMessage: 'Everything in {planName}, plus:',
    id: 'sx0HdFU57l',
    description:
      'Feature list heading with the user’s current plan name when more than three trial days remain',
  },
  titleFreeTrialClinician: {
    defaultMessage: "You're on a free trial of Clinician",
    id: 'tcAYDnuh4T',
    description:
      'Modal heading when the user has more than three days left on a Clinician trial',
  },
  titleLastDayClinician: {
    defaultMessage: 'Today is your last day to keep your Clinician features',
    id: 'Yia/HtqXJ9',
    description:
      'Modal heading on the last day of a Clinician trial (zero days remaining)',
  },
  titleDaysLeftToKeepClinician: {
    defaultMessage:
      '{days, plural, one {1 day left to keep your Clinician features} other {# days left to keep your Clinician features}}',
    id: 'Z8lxL2Uh7q',
    description: 'Modal heading when one to three days remain on a Clinician trial',
  },
  loseAccessToday: {
    defaultMessage: "Today you'll lose:",
    id: 'EVQa2/SkAC',
    description:
      'Feature list heading on the last day of a Clinician trial before downgrade',
  },
  loseAccessDays: {
    defaultMessage:
      "{days, plural, one {In # day you'll lose:} other {In # days you'll lose:}}",
    id: 'BKhMQaPEG6',
    description:
      'Feature list heading when one to three days remain on a Clinician trial',
  },
  contactAdminToUpgrade: {
    defaultMessage: 'Contact your Team Administrator to upgrade',
    id: '9cFWIra4Cx',
    description:
      'Tooltip when a non-admin team member cannot upgrade from the Clinician modal',
  },
  contactSalesToUpgrade: {
    defaultMessage: 'Contact Sales to upgrade',
    id: 'NQRNkPKx6g',
    description:
      'Tooltip when upgrade must go through sales on a non-Stripe-managed team',
  },
});
